import api from '../../../services/api';
import buildQuery from 'odata-query'

export const LPPS_URL = '/lpp'
export const STANDBY_URL = '/StandardStandBy'
export const TRAINING_URL = '/traininguser'

// Pega todas as LPP
export function getAllLpp() {
    return api.get(LPPS_URL)
}

// Retorna os dados por filtro
export function getByFilters ( queryParams ) {
    return api.get(`${LPPS_URL}/odata${queryParams}`)
}

// Retorna os dados por filtro
export function fetchDataViewStandBy(id) {
    return fetchData(id, STANDBY_URL)
}

// Retorna a view
export function fetchDataViewLPP ( id, trainingData = true ) {
    return fetchData(id, LPPS_URL, trainingData)
}

// Retorna a view
export function fetchDataById(id) {
    return api.get(`${LPPS_URL}/odata/` + buildQuery({
        filter: {
            id: parseInt(id)
        },
        select: ['identifier']
    }))
}

export function fetchData(id, url, trainingData = false) {
    if (trainingData) {
        return api.get(`${url}/odata/` + buildQuery({
            filter: {
                id: parseInt(id)
            },
            expand: {
                steps: true,
                trainingUsers: {
                    select: ['userId'],
                    filter: { user: { status: true } },
                    expand: {
                        user: {
                            select: ['id', 'name', 'sap'],
                            expand: [
                                'companyRole',
                                'deparment'
                            ]
                        }
                    }
                },
                structure: {
                    select: ['name']
                }
            }
        }))
    }
    else
        return api.get(`${url}/odata/` + buildQuery({
            filter: {
                id: parseInt(id)
            },
            expand: {
                steps: true,                
                structure: {
                    select: ['name']
                }
            }
        }))
}

export function fetchTraining(id, version) {
    return api.get(`${TRAINING_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(id),
            version: version,
            user: { status: true }
        },
        expand: {
            users: {
                expand: {
                    user: {
                        select: ['id', 'name', 'sap'],
                        expand: [
                            'companyRole',
                            'deparment'
                        ]                        
                    }
                }
            }
        },
        count: true,
    }))
}

//return as few data as possible
export function fetchTrainingSimple(standardId) {
    return api.get(`${TRAINING_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(standardId),
            isInFarol: true,
            user : { status : true}
        },
        /*select: ['id'],
        expand: {
            users: {
                select: ['userId', 'status', 'farolLvl20', 'farolLvl202', 'farolLvl70']
            }
        },*/
        count: true,
    }))
}

export async function fetchTrainingSpecificUser(standardId, userId) {
    return api.get(`${TRAINING_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(standardId)            
        },
        expand: {
            users: {
                filter:
                {
                    userId: parseInt(userId)        
                },
                select: ['userId','status']             
            }
        },
        select: ['standardId'],
        count: true,
    }))
}



//Salva a LPP
export function updateLpp(lpp) {
    return api.put(lpp);
}

export function getLppStandby(queryParams) {
    return api.get('/StandardStandBy/odata/' + buildQuery(queryParams));
}